import { ColumnHeader } from '@src/components/Table/components';
import { SortDirection } from '@src/types/common';
import { cleanNumberDisplay, getCurrencySymbol } from '@src/utilities/currency';
import dayjs from 'dayjs';
import { TFunction } from 'i18next';

interface RenderColumnsProps {
  t: TFunction;
  sorterState?: {
    sortBy: string | null;
    sortOrder: SortDirection | null;
    onSortChange: (columnKey: string, order: SortDirection | null) => void;
  };
}

export function RenderColumns({ t, sorterState }: RenderColumnsProps) {
  const baseColumns = [
    {
      key: 'purchaseDate',
      dataIndex: 'purchaseDate',
      title: t('pages.affiliate.referrals.commissions.dataTable.purchaseDate'),
      width: '100px',
      sortable: false,
      render: (_, item) => {
        return dayjs(item.purchaseDate).format('MM/DD/YYYY - HH:mm A');
      },
    },
    {
      key: 'yourCommission',
      dataIndex: 'yourCommission',
      title: t(
        'pages.affiliate.referrals.commissions.dataTable.yourCommission'
      ),
      render: (_, item) => {
        return `${getCurrencySymbol('EUR')} ${cleanNumberDisplay(item.yourCommission)}`;
      },
    },
    {
      key: 'totalAmount',
      dataIndex: 'totalAmount',
      title: t('pages.affiliate.referrals.commissions.dataTable.totalAmount'),
      render: (_, item) => {
        return `${getCurrencySymbol('EUR')} ${cleanNumberDisplay(item.totalAmount)}`;
      },
    },
  ];

  const enhancedColumns = [
    ...baseColumns.map((col) => ({
      ...col,
      title: (
        <ColumnHeader
          title={col.title}
          columnKey={col.dataIndex}
          sortable={!!col.sortable}
          sortOrder={
            sorterState?.sortBy === col.key ? sorterState.sortOrder : null
          }
          onSortChange={(order) => sorterState?.onSortChange(col.key, order)}
        />
      ),
    })),
  ];

  return enhancedColumns;
}
